<script lang="ts">
    import { _ } from "svelte-i18n"
    import { content, location, preselectedDealerNumber } from "../../store"
    import ContentBlocks from "../layout/ContentBlocks.svelte"
    import { apiBaseURL, services, title } from "../../config"
    import ContactForm from "./service/ContactForm.svelte"
    import Index from "../SEO/Index.svelte"
</script>

<Index title="{$_('service.service-area')}" metaDescription="{$_('meta.description')}" />
<div id="headerpic"><img src="media/headerpic3.jpg" alt="" /></div>
<section class="section-type-1 section_padding">
    <div class="container-fluid">
        <h1>{$_("service.service-area")}</h1>

        <div class="row">
            <div class="col-md-2">
                <div class="firstheadline">
                    <h2><a href="/service">{$_("service.service")}</a></h2>
                </div>
                <div id="sitenav">
                    <ul>
                        {#each services as item}
                            {#if !$preselectedDealerNumber || item.inPreselectedDealerView}
                                <li>
                                    <a href="/service/{item.url}">{item.title}</a>
                                </li>
                            {/if}
                        {/each}
                    </ul>
                </div>
            </div>
            <div class="col-md-10">
                {#if $location.path == "/service"}
                    <div class="services">
                        {#each services as item}
                            <div class="item">
                                <div class="icon">
                                    <svelte:component this="{item.icon}" size="40" />
                                </div>
                                <div class="text">
                                    <h4>{item.title}</h4>
                                    <p>{item.description}</p>
                                </div>
                                <!-- svelte-ignore a11y-missing-content -->
                                <a href="/service/{item.url}"></a>
                            </div>
                        {/each}
                    </div>
                {/if}
                {#each services as item}
                    {#if $location.path == "/service/" + item.url}
                        <div class="firstheadline mainheadline">
                            <h2>{item.title}</h2>
                        </div>
                        {#if $content}
                            <div class="contentblocks">
                                <ContentBlocks
                                    accordeon
                                    imageBase="{apiBaseURL + '/content/' + $content.id + '/'}"
                                    blocks="{$content.middle}"
                                />
                            </div>
                        {/if}
                        {#if item.url == "kontakt" || item.url == "contact"}
                            <ContactForm />
                        {/if}
                    {/if}
                {/each}
            </div>
        </div>
    </div>
</section>

<style lang="less">
    @import "../../css/variables.less";
    :global .contentblocks {
        .section_padding {
            padding: 0px;
            .container {
                margin: 0px;
                padding: 0px;
                width: 100%;
            }
        }
    }
    .firstheadline {
        height: 60px;
        border-bottom: 1px dashed var(--border-color-2);
        .flex();
        justify-content: flex-end;
        flex-direction: column;
        padding-bottom: 10px;
        margin-bottom: 20px;
        h2 {
            margin: 0px;
            font-size: 1.2rem;

            a {
                color: var(--comp--section-type-1--color);
                &:hover {
                    color: var(--primary);
                }
            }
        }
        &.mainheadline {
            h2 {
                font-size: 1.6rem;
            }
        }
    }

    .services {
        .flex();
        flex-wrap: wrap;
        margin: -1%;
        @media (max-width: 420px) {
            flex-direction: column;
        }
        .item {
            transition: all 0.3s;
            position: relative;
            width: 31%;
            margin: 1%;
            .flex();
            align-items: center;
            @media (max-width: 1100px) {
                width: 48%;
            }
            @media (max-width: 600px) {
                flex-direction: column;
            }
            @media (max-width: 420px) {
                width: 100%;
                flex-direction: row;
                margin-bottom: 20px;
            }
            .icon {
                transition: all 0.3s;
                width: 100px;
                height: 100px;
                border: solid 1px #999;
                border-radius: 100%;
                padding: 10px;
                overflow: hidden;
                flex-shrink: 0;
                .flex();
                align-items: center;
                justify-content: center;
                flex-direction: column;
                margin-right: 30px;
                margin-bottom: 10px;
                @media (max-width: 900px) {
                    width: 10vw;
                    height: 10vw;
                }
                @media (max-width: 600px) {
                    width: 100px;
                    height: 100px;
                    margin-right: 0;
                }
                @media (max-width: 420px) {
                    margin-right: 10px;
                    width: 80px;
                    height: 80px;
                    margin-bottom: 0px;
                }
            }
            .text {
                width: 60%;
                line-height: 1.2;
                .flex();
                flex-direction: column;
                justify-content: center;
                h4 {
                    font-size: 1.3rem;
                    margin-top: 0px;
                    margin-bottom: 5px;
                    color: var(--primary);
                }
                p {
                    margin: 0px;
                }
                @media (max-width: 600px) {
                    width: 100%;
                }
            }
            a {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                cursor: pointer;
            }
            &:hover {
                color: var(--primary);
                .icon {
                    border-color: var(--primary);
                }
            }
        }
    }
</style>
